import { Button } from "@progress/kendo-react-buttons";
import { GridToolbar } from "@progress/kendo-react-grid";
import { useDispatch } from "react-redux";
import React from "react";
import PropTypes from 'prop-types';
import { setButtonsState } from "../../../redux/slices/appStateSlice";

export default function CampagneToolbar(props) {
    const dispatch = useDispatch();

    return <GridToolbar>
        <div className="k-d-flex k-w-full k-justify-content-end">
            <span className="k-d-flex k-grow-0 k-shrink-0">
                <Button icon="button" selected={props.buttonsState.buttons} onClick={() => dispatch(setButtonsState({ buttons: true, calendar: false }))} togglable={true} style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                <Button icon="calendar" selected={props.buttonsState.calendar} onClick={() => dispatch(setButtonsState({ buttons: false, calendar: true }))} togglable={true} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} />
            </span>
        </div>
    </GridToolbar>;
}

CampagneToolbar.propTypes = {
    buttonsState: PropTypes.any
};